import React, {Children, useEffect, useState, useRef} from 'react';
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons'
import { Navbar } from 'react-bootstrap';
import AuthService from '../../services/Auth/AuthService';
import SchoolDataService from '../../services/school/SchoolService';
import PasswordChecklist from "react-password-checklist"
import {useLocation} from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

const newStudent = () => {
  return {};
}

export default function RegistrationForm({ setRegister }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [termsAccepted, setTermsAccepted] = useState();
  const [students, setStudents] = useState([newStudent()])
  const [errorMessage, setErrorMessage] = useState();
  const [schools, setSchools] = useState([]);
  const [registrationFormSuccess, setRegistrationFormSuccess] = useState('');

  const search = useLocation().search;
  const captchaRef = useRef(null);

  useEffect(() => {
    document.title = "Cool Kids English - Registration Form"

    SchoolDataService.getAll()
      .then((response) => {
        setSchools(response.filter(s => !s.kindergarten));
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const handleSchoolSelectionForStudent = (event, student) => {
    const { value } = event.target;
    const selectedSchool = schools.find(s => s.id === value);
    student.school = selectedSchool;
    
    setStudents([...students]);

  };

  const handleSubmit = async e => {
    e.preventDefault();

    let token = captchaRef.current.getValue();
    captchaRef.current.reset();

    if (token) {
      const valid_token = await AuthService.verifyCaptchaToken(token);
      //setValidToken(valid_token);
      console.log(valid_token);
      
      if (valid_token?.success === true) {
        console.log("verified");
      } else {
        console.log("not verified - bot!");
        return;
      }
    } else {
      setErrorMessage(`Bitte drücken Sie "I'm not a robot"`);
      return;
    }

    const errorFields = []
    if (!firstName) {
      errorFields.push('Vorname');
    }
    if (!lastName) {
      errorFields.push('Nachname');
    }
    if (!email) {
      errorFields.push('Email');
    }
    if (!phoneNumber) {
      errorFields.push('Telefonnummer');
    }

    students.forEach((s,i) => {
      if (!s.firstName) {
        errorFields.push(`Student ${i+1} Vorname`);
      }
      if (!s.lastName) {
        errorFields.push(`Student ${i+1} Nachname`);
      }
      if (!s.school) {
        errorFields.push(`Student ${i+1} Schule`);
      }
      if (!s.year) {
        errorFields.push('Schulstufe');
      }
      if (!s.className) {
        errorFields.push('Klasse');
      }
      if (!s.parentNotesTagesheim) {
        errorFields.push(`Student ${i+1} Tagesheim`);
      }
      if (!s.school) {
        errorFields.push(`Student ${i+1} Schule`);
      }
    });

    if (errorFields.length) {
      setErrorMessage(`Bitte spezifizieren Sie die folgenden Antworten: ${errorFields.join(', ')}`);
      return;
    } else if (!termsAccepted) {
      setErrorMessage(`Bitte lesen und akzeptieren Sie die Allgemeinen Geschäftsbedingungen`);
      return;
    }

    setErrorMessage('');
    //now submit - add the tagesheim to the weitere info
    students.forEach(s => {
      s.parentNotes = `Notes
${s.parentNotes ? s.parentNotes : '-'}

Tagesheim
${s.parentNotesTagesheim ? s.parentNotesTagesheim : '-'}
      
Allergien
${s.parentNotesAllergien ? s.parentNotesAllergien : '-'}`
    });
    const response = await AuthService.submitRegisterationForm(
      { 
        parent: {
          firstName, lastName, email, address, phoneNumber
        },
        children: students
      }
    );
    if (response.status === 409) {
      //setAlreadyRegistered(true)
    } else if (response.status === 200) {
      const responseBody = await response.json();
      setRegistrationFormSuccess(responseBody.body.submission);
    }
  }

  const addChild = (e) => {
    e.preventDefault();
    setStudents([...students, newStudent()])
  }

  const goToLogin = () => {
    setRegister(false);
  }

  const showTermsAndConditions = () => {
    window.open('http://www.coolkidsenglish.at/extras/cke-terms.pdf', '_blank', 'noopener,noreferrer');
  }

  const handleStudentValueChange = (event, student, index) => {
    console.log('handle student value change', student, index);
    const { name, value } = event.target;

    const fieldName = name.split('_')[1]
    student[fieldName] = value;
    setStudents([...students]);
  }

  const removeChild = (e, student, index) => {
    e.preventDefault();
    students.splice(index, 1);
    setStudents([...students]);
  }

  const renderStudent = (student, index) => {
    return (
      <div style={{marginBottom: 15, paddingTop: 4, paddingBottom: 4}}>
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <h4>{`Kind ${index+1}`}</h4>
          { index > 0 && <button className="btn" onClick={(e) => removeChild(e, student, index)}><FontAwesomeIcon style={{fontSize: 24, color: "#63a3be"}} icon={faMinusCircle}/></button>}
        </div>
        
        <div className="d-flex justify-content-between">
          <div className="form-group col-5" >
            <label htmlFor={`student_firstName_${index}`}>Vorname *</label>
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id={`student_firstName_${index}`}
              name={`student_firstName_${index}`}
              value={student.firstName}
              onChange={(e) => handleStudentValueChange(e, student, index)}
            />
          </div>
          <div className="form-group col-5" >
            <label htmlFor={`student_lastName_${index}`}>Nachname *</label>
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id={`student_lastName_${index}`}
              name={`student_lastName_${index}`}
              value={student.lastName}
              onChange={(e) => handleStudentValueChange(e, student, index)}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div className="form-group col-12" >
            <label htmlFor="school">Schule *</label>
            <select
              className="form-select"
              id="school"
              name="school"
              value={student.school ? student.school.id : ''}
              onChange={(e) => handleSchoolSelectionForStudent(e, student, index)}>
              <option value="0" selected >- Schule -</option>
              {schools.map((school) => <option key={school.id} value={school.id}>{school.name}</option>)}
            </select>
          </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="form-group col-4" >
              <label htmlFor={`student_year_${index}`}>Schulstufe *</label>
              <select
                className="form-select"
                id={`student_year_${index}`}
                name={`student_year_${index}`}
                value={student.year}
                onChange={(e) => handleStudentValueChange(e, student, index)}>
                <option value="" selected disabled hidden></option>
                {['1','2','3','4'].map((y) => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
            <div className="form-group col-8" >
              <label htmlFor={`student_className_${index}`}>Klasse * <span style={{fontSize: 12, fontStyle: 'italic'}}>zb. 1a, Hase</span></label>
                <input
                  type="text"
                  className="form-control"
                  id={`student_className_${index}`}
                  name={`student_className_${index}`}
                  value={student.className}
                  onChange={(e) => handleStudentValueChange(e, student, index)}
                />
            </div>
          </div>
          <br/>
          {
            student.school?.parentInfo && <div style={{marginTop: 10}}>
              <div>Termine für <span style={{fontWeight: 'bold'}}>{student.school?.name}</span></div>
              <div style={{fontStyle: 'italic'}}>{student.school?.parentInfo}</div>
              &nbsp;
            </div>
          }
          <br/>
          <div className="form-group">
            <label htmlFor={`student_parentNotes_${index}`}>
            Tagesheim *
              <span className="smallInfo"></span>
            </label>
            <div className="smallInfo">(bitte ausfüllen) ja oder nein?<br/>(an welchen Tagen ist ihr Kind angemeldet)</div>
            <textarea
              style={{height: 50}}
              type="text"
              className="form-control"
              id={`student_parentNotesTagesheim_${index}`}
              name={`student_parentNotesTagesheim_${index}`}
              value={student.parentNotesTagesheim}
              onChange={(e) => handleStudentValueChange(e, student, index)}
            />
          </div>
          <br/>
          <div className="form-group">
            <label htmlFor={`student_parentNotes_${index}`}>
            Allergien
              <span className="smallInfo"></span>
            </label>
            <div className="smallInfo"></div>
            <textarea
              style={{height: 25}}
              type="text"
              className="form-control"
              id={`student_parentNotesAllergien_${index}`}
              name={`student_parentNotesAllergien_${index}`}
              value={student.parentNotesAllergien}
              onChange={(e) => handleStudentValueChange(e, student, index)}
            />
          </div>
          <br/>
          <div className="form-group">
            <label htmlFor={`student_parentNotes_${index}`}>
              Weitere Informationen
            </label>
            <div className="smallInfo">Bitte geben Sie Alle möglichen Termine/Tage an, damit ich die Gruppen entsprechend einteilen kann. Danke!</div>
            <textarea
              style={{height: 50}}
              type="text"
              className="form-control"
              id={`student_parentNotes_${index}`}
              name={`student_parentNotes_${index}`}
              value={student.parentNotes}
              onChange={(e) => handleStudentValueChange(e, student, index)}
            />
          </div>
          
      </div>
    )
  }

  const renderBody = () => {
    
    if (registrationFormSuccess === 'verify') {
      return (
      <div className="edit-form">
        <h1>Anmeldung Coolkidsenglish</h1>
        <div>Vielen Dank für Ihre Einreichung.</div>
        <hr/>
        <div>Bitte überprüfen Sie Ihren Posteingang für eine Email von <a href={`jim@coolkidsenglish.at`}>jim@coolkidsenglish.at</a>.  Folgen Sie den Anweisungen, um Ihre Registrierung abzuschließen.</div>
      </div>
      )
    } else if (registrationFormSuccess === 'complete') {
      return (
        <div className="edit-form">
          <h1>Anmeldung Coolkidsenglish</h1>
          <div>Vielen dank, Sie sind jetzt Angemeldet.</div>
          <hr/>
          <div></div>
        </div>
        )
    }

    return (
      <div className="edit-form">
        <h1>Anmeldung Coolkidsenglish</h1>
        <div>Bitte geben Sie Ihre Informationen ein.</div>
        <form id="loginForm" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id="email"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="title">Vorname *</label>
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id="firstName"
              name="firstName"
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="title">Nachname *</label>
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id="lastName"
              name="lastName"
              value={lastName}
              onChange={e => setLastName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="title">Adresse</label>
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id="address"
              name="address"
              value={address}
              onChange={e => setAddress(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="title">Telefonnummer *</label>
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id="phoneNumber"
              name="phoneNumber"
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
            />
          </div>
          <hr/>
          <div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <h3 style={{flex: 1}}>Kinder</h3>
            </div>
            <div className="smallInfo">Bitte fügen Sie Details zu allen Kindern hinzu, die Sie anmelden möchten.</div>
            {students.map((s,i) => renderStudent(s, i))}
            <button className="btn btn-primary" onClick={addChild}>+ Weitere Kinder</button>
          </div>
          <hr/>
          <div className="form-group">
            <input
              className="form-check-input"
              type="checkbox"
              id="termsAccepted"
              name="termsAccepted"
              checked={termsAccepted}
              onClick={(event) => setTermsAccepted(event.target.checked)}
            />
            <label htmlFor="termsAccepted" className="form-check-label">&nbsp;Ich habe die&nbsp;<a href={`http://www.coolkidsenglish.at/extras/cke-terms.html?nocache=${new Date().getTime()}`} target="_blank" rel="noopener noreferrer">Geschäftsbedingungen</a> gelesen und akzeptiere sie.</label>
          </div>
          { errorMessage && <div style={{color: 'red'}}>{errorMessage}</div>}
          <ReCAPTCHA
              ref={captchaRef}
              sitekey='6LfsobklAAAAACT-HOzlobSbE98lvywan7TSI6mZ'
            />
          <div className="buttonRow">
            <button
                type="submit"
                className="btn btn-primary"
              >
                Bestätigen
            </button>
          </div>
        </form>
      </div>
    )
  }

  return(
    <div className="App">
      <title>Cool Kids English Parent Portal - Anmeldung</title>
      <Navbar bg="primary" variant="dark" expand="md">
        <Navbar.Brand href="#home"><img alt="logo" className="logo" src={require('../../images/logo.png').default}/></Navbar.Brand>
        <h1>Anmeldung</h1>
      </Navbar>
      <div className="col-md-6" style={{margin: '10px'}}>
        {renderBody()}
      </div>
    </div>
  )
}
